import React, { Component } from 'react';
import WheelIndicator from 'wheel-indicator'
var indicator
class Scroll extends Component {
  componentDidMount () {
    indicator = new WheelIndicator({
      elem: this.scroll,
      preventMouse: this.props.preventMouse,
      callback: (e) => {
        //console.log(e.direction, this.props.preventMouse) // "up" or "down"
        this.props.scroll(e)
      }
    })
    // indicator.setOptions({preventMouse: true})
  }

  scrollRef = (node) => {this.scroll = node}


  componentWillReceiveProps (newProps) {
    if (newProps.preventMouse !== this.props.preventMouse) {
      indicator.setOptions({preventMouse: newProps.preventMouse})
    }
  }

  render () {
    return (
      <div ref={this.scrollRef}>
        {this.props.children}
      </div>
    )
  }
}

export default Scroll


// WEBPACK FOOTER //
// ./src/components/scroll/scroll.js